import { Dispatch } from 'redux';
import { USER_KEY } from '../../helpers/constants';
import history from '../../helpers/history';
import { AuthenthicatedUserInfo } from '../../interfaces';
import { SigninAction, SignoutAction, CompleteProfileAction } from '../actions/auth.action';
import { ActionType } from '../action_types';

export const signin = (user: AuthenthicatedUserInfo) => async (dispatch: Dispatch<SigninAction>) => {
  await localStorage.setItem(USER_KEY, JSON.stringify(user));

  dispatch({
    type: ActionType.SIGNIN,
    payload: {
      user,
    },
  });
};

export const signout = () => async (dispatch: Dispatch<SignoutAction>) => {
  await localStorage.removeItem(USER_KEY);

  dispatch({
    type: ActionType.SIGNOUT,
  });

  history.push('/');
};

export const completeProfile = (user: AuthenthicatedUserInfo) => async (dispatch: Dispatch<CompleteProfileAction>) => {
  await localStorage.setItem(USER_KEY, JSON.stringify(user));

  dispatch({
    type: ActionType.COMPLETE_PROFILE,
    payload: {
      user,
    },
  });
};
